import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";

import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { useLocalization } from "@shared-ui/localization-context";

export function DestinationOverallRating({
  totalReviews,
  avgRating,
  toggleAllDestinationReviews,
  nameForTracking,
}: {
  totalReviews: number;
  avgRating: number;
  toggleAllDestinationReviews: () => void;
  nameForTracking: string;
}) {
  const { formatText } = useLocalization();
  const ratingDescriptor = avgRating >= 4 ? formatText("destinationReviews.topDestination") : "";

  const ButtonTracked = FlexClickTracker(UitkTertiaryButton);

  return (
    <>
      <UitkLayoutFlexItem className="DestinationReviewAverageRating all-y-margin-two xl-y-margin-four l-y-margin-four">
        <div>
          <Viewport>
            <ViewSmall>
              <p className="DestinationReviewAverageRatingText uitk-type-500">
                <span className="uitk-type-medium">{avgRating}</span>
                /5
                <span className="uitk-type-400 all-l-padding-two">{ratingDescriptor}</span>
              </p>
            </ViewSmall>
            <ViewLarge>
              <p className="DestinationReviewAverageRatingText uitk-type-600">
                <span className="uitk-type-medium">{avgRating}</span>
                /5
                <span className="all-l-padding-two">{ratingDescriptor}</span>
              </p>
            </ViewLarge>
          </Viewport>
        </div>
      </UitkLayoutFlexItem>

      <UitkLayoutFlexItem className="all-y-margin-two xl-y-margin-four l-y-margin-four">
        <div>
          <ButtonTracked
            className="DestinationReviewSeeAllRatings all-cell-1-6 uitk-type-medium"
            onClick={toggleAllDestinationReviews}
            text={formatText("destinationReviews.numberOfReviews", totalReviews.toLocaleString())}
            rfrr="Default.OpenReviews"
            moduleName={nameForTracking}
            linkName="RFRR Action Event"
          >
            <UitkIcon className="all-l-padding-two" name="chevron_right" size={UitkIconSize.SMALL} />
          </ButtonTracked>
        </div>
      </UitkLayoutFlexItem>
    </>
  );
}

export default DestinationOverallRating;
